import { createBrowserRouter } from "react-router-dom";
import AppLayout from "../router/AppLayout";
import Contact from "../components/Contact/Contact";
import Home from "../components/Home/Home";
import Certificate from "../components/Certificate/Certificate";
import Project from "../components/Project/Project";
import Skill from "../components/Skill/Skill";
import ErrorElement from "./ErrorElement";

const router = createBrowserRouter([
     {
          path: "",
          element: <AppLayout />,
          errorElement: <ErrorElement />,
          children: [
               { path: "", element: <Home /> },
               { path: "skill", element: <Skill /> },
               { path: "project", element: <Project /> },
               { path: "contact", element: <Contact /> },
               { path: "certificate", element: <Certificate /> },
          ],
     },
]);

export default router;
